import { render, staticRenderFns } from "./simpleTextImage.vue?vue&type=template&id=69a84dd4"
import script from "./simpleTextImage.vue?vue&type=script&lang=ts"
export * from "./simpleTextImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports